import { connect } from 'react-redux'
import { getResponseByRequestName } from 'modules/redux-gateway'

import { actions, selectors } from '../'

import { TagsEditor } from '../components'

const mapStateToProps = (state, props) => {
  const response = getResponseByRequestName(state, 'AvailableTags')
  const tags =
    (response &&
      response.AvailableTags &&
      response.AvailableTags.map((name) => ({
        name,
        ItemType: props.ItemType,
        ItemPublicKey: props.Id,
      }))) ||
    []
  const noteTags = selectors.getTags(state, props.Id)
  const noteTagHash = {}
  noteTags.forEach((tag) => {
    noteTagHash[tag.name] = tag
  })
  tags.forEach((tag, indx) => {
    tags[indx] = noteTagHash[tag.name] || tag
  })
  return {
    Id: props.Id,
    tags,
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch,
})

const mergeProps = ({ tags, ...stateProps }, { dispatch }, props) => {
  const updateFilter =
    ({ name, IsActive = false }) =>
    () => {
      const newTags = tags.map((tag) =>
        tag.name === name
          ? {
              ...tag,
              IsActive: !IsActive,
              ItemType: props.ItemType,
              ItemPublicKey: props.Id,
            }
          : tag
      )
      dispatch(actions.changeTags(newTags, props.Id))
    }

  const selectAll = (bool) => () => {
    const inverseTags = tags.map((tag) => ({ ...tag, IsActive: bool }))
    dispatch(actions.changeTags(inverseTags, props.Id))
  }

  return {
    tags,
    ...stateProps,
    updateFilter,
    selectAll,
    ...props,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(TagsEditor)
